import { render, staticRenderFns } from "./CategoriesComponent.vue?vue&type=template&id=bc1003ba&scoped=true"
import script from "./CategoriesComponent.vue?vue&type=script&lang=js"
export * from "./CategoriesComponent.vue?vue&type=script&lang=js"
import style0 from "./CategoriesComponent.vue?vue&type=style&index=0&id=bc1003ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1003ba",
  null
  
)

export default component.exports